import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RootGuard } from './root.guard';

const routes: Routes = [
  { 
    path: '', component: AppComponent, canActivate: [RootGuard],
    children: [
      { path: 'login', component: LoginComponent },
    ]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
